<template>
  <!-- 用户访问供应商数据授权 -->
  <div class="" style="height: 100%">
    <list-page>
      <search-condition :show-border="false" :show-shadow="false">
        <template #default>
          <el-input v-model="searchInfo.searchKey" placeholder="供应商名称/分类名称" @keydown.enter="resetSearch" clearable>
            <template #prefix>关键字</template>
          </el-input>
          <el-select v-model="searchInfo.searchType" placeholder="授权方式" clearable>
            <template #prefix>授权方式</template>
            <el-option label="单个供应商" :value="1"/>
            <el-option label="按分类" :value="2"/>
          </el-select>
          <employee-select v-model="searchInfo.employeeId" placeholder="请选择操作员">
            <template #prefix>操作员</template>
          </employee-select>
        </template>
        <template #option>
          <page-button el-type="primary" @click="resetSearch">查询</page-button>
          <page-button el-type="success" @click="toAddAuth">添加授权</page-button>
          <page-button el-type="warning" @click="toShowResult">查看结果</page-button>
        </template>
      </search-condition>
      <list-table background-color="#FFF">
        <yq-table :data="dataList" height="100%" stripe border page-name="supplierAccess" empty-text="暂无授权数据">
          <yq-table-column label="授权方式" prop="authType" align="center">
            <template v-slot="{row}">
              <el-tag size="small" :type="row.authType === 2 ? 'warning' : 'primary'">{{row.authTypeName || (row.authType === 2 ? '按分类' : '单个供应商')}}</el-tag>
            </template>
          </yq-table-column>
          <yq-table-column label="被授权职员" prop="staffName" width="120rem" :show-overflow-tooltip="true"/>
          <yq-table-column label="授权数据" prop="authDataName" min-width="180rem" :show-overflow-tooltip="true">
            <template v-slot="{row}">{{row.merchantRemarkName || row.categoryName}}</template>
          </yq-table-column>
          <yq-table-column label="授权日期" width="140rem" :show-overflow-tooltip="true">
            <template v-slot="{row}">{{formatTime(row.createdTime)}}</template>
          </yq-table-column>
          <yq-table-column label="操作员" prop="grantorName" width="120rem" :show-overflow-tooltip="true"/>
          <yq-table-column label="操作" prop="options" :align="'center'" fixed="right" width="120rem" :show-overflow-tooltip="false">
            <template v-slot="{row}">
              <table-button-group label="更多操作">
                <table-button type="delete" el-type="danger" message="是否确认取消授权" @click="toDelete(row)">删除</table-button>
              </table-button-group>
            </template>
          </yq-table-column>
        </yq-table>
      </list-table>
      <form-page v-model:page-number="searchInfo.pageNumber" v-model:page-size="searchInfo.pageSize"
                 :total-count="searchInfo.totalCount" @onLoad="queryList" :show-border="false" :show-shadow="false"/>
    </list-page>
    <el-dialog v-model="showAdd" title="添加供应商授权" dialog-width="1" :close-on-click-modal="false">
      <div class="grant-tip">
        <yq-icon name="element-ui_info" style="margin-right: 6px"/>
        单个供应商授权：指定若干供应商；按分类授权：指定供应商分类，分类下所有供应商将自动授权。
      </div>
      <form-items :data="currentData" ref="dialogData" :columns="1" label-width="2.4rem">
        <form-item label="授权方式" :required="true" name="authType" error-message="请选择授权方式">
          <el-select v-model="currentData.authType" placeholder="请选择授权方式" style="width: 100%">
            <el-option label="单个供应商" :value="1"/>
            <el-option label="按分类" :value="2"/>
          </el-select>
        </form-item>
        <form-item label="被授权职员" :required="true" name="staffId" error-message="缺少被授权职员">
          <employee-select v-model="currentData.staffId" placeholder="请选择职员" :disabled="true"/>
        </form-item>
        <form-item label="授权供应商" v-if="currentData.authType === 1" col-span="2" :show-block="true">
          <div class="grant-select-wrap">
            <supplier-select v-model="currentData.partnerListIds" placeholder="请选择供应商" :multi="true" :query-api="queryAllSupplierApi" @change="selectSupplier2Current" style="width: 100%;"/>
            <div class="grant-count" v-if="currentData.partnerList.length > 0">已选择 {{currentData.partnerList.length}} 个供应商</div>
          </div>
        </form-item>
        <form-item label="授权分类" v-if="currentData.authType === 2" col-span="2" :show-block="true">
          <div class="grant-select-wrap">
            <el-tree-select v-model="currentData.categoryIdList" :data="partnerCategory" default-expand-all check-strictly
                            :render-after-expand="true" placeholder="请选择供应商分类（可多选）" multiple clearable
                            :props="{children: 'children', label: 'dictName'}" node-key="dictCode" style="width: 100%"/>
            <div class="grant-count" v-if="currentData.categoryIdList.length > 0">已选择 {{currentData.categoryIdList.length}} 个分类</div>
          </div>
        </form-item>
      </form-items>
      <template #footer>
        <page-button @click="showAdd = false">取消</page-button>
        <page-button el-type="primary" @click="saveAuth">保存</page-button>
      </template>
    </el-dialog>
    <el-dialog v-model="authResultShow" title="供应商授权最终结果" dialog-width="4">
      <dialog-table>
        <separator-page :show-border="true" :show-shadow="false">
          <template #category>
            <tree-dictionary v-model:dictionary-list="partnerCategoryAll" @clickCategory="clickCategory" :disabled="true" :filter="true" placeholder="输入供应商分类名称过滤"/>
          </template>
          <template #default>
            <list-page>
              <search-condition :show-border="false" :show-shadow="false">
                <template #default>
                  <el-input v-model="authResultSearchInfo.searchKey" placeholder="供应商名称/手机号/分类名称" @keydown.enter="resultResetSearch">
                    <template #prefix>关键字</template>
                  </el-input>
                </template>
                <template #option>
                  <page-button type="read" el-type="primary" @click="resultResetSearch">查询</page-button>
                </template>
              </search-condition>
              <list-table :show-shadow="false">
                <yq-table :data="authResultList" height="100%" stripe border page-name="supplierAccess">
                  <yq-table-column label="供应商名称" prop="merchantRemarkName" min-width="180rem" :show-overflow-tooltip="true"/>
                  <yq-table-column label="供应商分类" prop="categoryName" width="120rem" :show-overflow-tooltip="true"/>
                  <yq-table-column label="授权方式" prop="authType" align="center">
                    <template v-slot="{row}">
                      <el-tag size="small" :type="row.authType === 2 ? 'warning' : 'primary'">{{row.authTypeName || (row.authType === 2 ? '按分类' : '单个供应商')}}</el-tag>
                    </template>
                  </yq-table-column>
                  <yq-table-column label="授权日期" width="140rem" :show-overflow-tooltip="true">
                    <template v-slot="{row}">{{formatTime(row.createdTime)}}</template>
                  </yq-table-column>
                  <yq-table-column label="操作员" prop="grantorName" width="120rem" :show-overflow-tooltip="true"/>
                  <yq-table-column label="操作" prop="options" :align="'center'" fixed="right" width="120rem" :show-overflow-tooltip="false">
                    <template v-slot="{row}">
                      <table-button-group label="更多操作">
                        <table-button type="delete" el-type="danger" message="是否确认删除该供应商" @click="toDeleteResult(row)">删除</table-button>
                      </table-button-group>
                    </template>
                  </yq-table-column>
                </yq-table>
              </list-table>
              <form-page v-model:page-number="authResultSearchInfo.pageNumber" v-model:page-size="authResultSearchInfo.pageSize"
                         :total-count="authResultSearchInfo.totalCount" @onLoad="resultQueryList" :show-border="false" :show-shadow="false"/>
            </list-page>
          </template>
        </separator-page>
      </dialog-table>
    </el-dialog>
  </div>
</template>

<script>
import ListPage from "@/components/h5/layout/ListPage";
import ListTable from "@/components/h5/layout/ListTable.vue";
import FormPage from "@/components/h5/layout/FormPage";
import PageButton from "@/components/h5/button/PageButton";
import FormItems from "@/components/h5/layout/FormItems.vue";
import FormItem from "@/components/h5/layout/FormItem.vue";
import {useRoute, useRouter} from "vue-router";
import Util from "@/util/util";
import SearchCondition from "@/components/h5/layout/SearchCondition.vue";
import Dictionary from "@/components/h5/data/Dictionary.vue";
import TableButton from "@/components/h5/button/TableButton.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import TableButtonGroup from "@/components/h5/button/TableButtonGroup.vue";
import commonApi from "@/api/commonApi";
import supplierGrantApi from "@/api/normal/common/supplierGrantApi";
import YqIcon from "@/components/YqIcon.vue";
import DialogTable from "@/components/h5/layout/DialogTable.vue";
import SeparatorPage from "@/components/h5/layout/SeparatorPage.vue";
import TreeDictionary from "@/components/h5/data/TreeDictionary.vue";
import EmployeeSelect from "@/components/h5/data/EmployeeSelect.vue";
import SupplierSelect from "@/components/h5/partner/SupplierSelect.vue";
import employeeApi from "@/api/normal/sys/employeeApi";

export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "EmployeeAccessSupplier",
  components: {
    EmployeeSelect, SupplierSelect,
    TreeDictionary, SeparatorPage,
    YqIcon,
    TableButtonGroup, YqTableColumn, TableButton, Dictionary,
    SearchCondition, DialogTable,
    PageButton, ListPage, ListTable, FormPage, FormItems, FormItem
  },
  data() {
    return {
      dataDetail: {},
      dataList: [],
      searchInfo: {pageNumber: 1},
      showAdd: false, // 添加授权
      currentData: {}, // 当前修改的数据
      authResultShow: false, // 显示授权结果
      authResultList: [], // 授权结果
      authResultSearchInfo: {pageNumber: 1},
      partnerCategory: [], // 供应商分类
      partnerCategoryAll: [], // 供应商分类（包含全部分类）
      targetEmployeeId: "",
      partnerList: [], // 供应商列表
      queryAllSupplierApi: employeeApi.querySupplierList
    };
  },
  beforeRouteLeave(to, from, next) {
    // 将当前页面数据进行缓存
    Util.cachePageData(this, to, from);
    next();
  },
  created() {
    this.targetEmployeeId = this.route.query.id;
    // 供应商分类
    commonApi.queryDictionaryTree("SUPPLIER_CATEGORY").then(list => {
      this.partnerCategory = list
      this.partnerCategoryAll = [{dictCode: "", dictName: "全部", children: list}]
    });
    this.resetSearch();
  },
  methods: {
    init() {

    },
    resetSearch() {
      this.searchInfo.pageNumber = 1;
      this.searchInfo.staffId = this.targetEmployeeId;
      this.queryList();
    },
    // 查询授权配置列表
    async queryList() {
      const {records, totalCount} = await supplierGrantApi.queryList(this.searchInfo);
      this.dataList = records || [];
      this.searchInfo.totalCount = totalCount;
      // 回填授权数据名称与授权方式名称
      for (const row of this.dataList) {
        row.authTypeName = row.authType === 2 ? "按分类" : "单个供应商";
      }
    },
    // 格式化时间
    formatTime(time) {
      if (!time) return "";
      return String(time).replace("T", " ").substring(0, 16);
    },
    // 删除授权（取消授权）
    async toDelete(row) {
      await supplierGrantApi.cancel(row.id);
      this.$message.success("已取消授权");
      this.resetSearch();
    },
    // 删除授权结果
    async toDeleteResult(row) {
      await supplierGrantApi.deleteResult(row.id);
      this.$message.success("已删除该授权结果");
      this.resultResetSearch();
    },
    // 查询授权结果
    resultResetSearch() {
      this.authResultSearchInfo.pageNumber = 1;
      this.resultQueryList();
    },
    // 查询授权结果列表
    async resultQueryList() {
      const {records, totalCount} = await supplierGrantApi.queryGrantResult({
        ...this.authResultSearchInfo,
        staffId: this.targetEmployeeId,
      });
      this.authResultList = records || [];
      this.authResultSearchInfo.totalCount = totalCount;
      // 授权方式名称
      this.authResultList.forEach(row => row.authTypeName = row.authType === 2 ? "按分类" : "单个供应商");
    },
    toAddAuth() {
      this.currentData = {
        authType: 1,
        categoryIdList: [],
        partnerList: [],
        staffId: this.targetEmployeeId,
      };
      this.showAdd = true;
    },
    toShowResult() {
      this.authResultShow = true;
      this.resultResetSearch();
    },
    selectSupplier2Current(val) {
      this.currentData.partnerList = val? val.split(",") : [];
    },
    // 保存授权
    async saveAuth() {
      if (!this.currentData.authType) {
        this.$message.error("请选择授权方式");
        return;
      }
      let detailList = [];
      let config = {authType: this.currentData.authType, staffId: this.targetEmployeeId};
      if (this.currentData.authType === 1) { // 按单个供应商授权
        const partners = this.currentData.partnerList || [];
        if (partners.length === 0) {
          this.$message.error("请选择授权供应商");
          return;
        }
        for (let i = 0; i < partners.length; i++) {
          detailList.push({...config, partnerId: partners[i]})
        }
      } else if (this.currentData.authType === 2) { // 按分类授权
        const categoryIds = this.currentData.categoryIdList || [];
        if (categoryIds.length === 0) {
          this.$message.error("请选择供应商分类");
          return;
        }
        // categoryIdList 是字典树节点的 dictCode 数组
        for (let i = 0; i < this.currentData.categoryIdList.length; i++) {
          detailList.push({...config, categoryId: this.currentData.categoryIdList[i]})
        }
      }
      try {
        await supplierGrantApi.save(detailList);
        this.$message.success("授权成功");
        this.showAdd = false;
        this.resetSearch();
      } catch (e) {
        // 保留弹框，便于用户修正
      }
    },
    clickCategory(data) {
      this.authResultSearchInfo.categoryId = data.dictCode;
      this.resultResetSearch();
    }
  }
};
</script>

<style lang="scss" scoped>
.grant-tip {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: var(--yq-font-color-tips, #909399);
  background: var(--el-color-primary-light-9, #ecf5ff);
  border-radius: 4px;
  padding: 8px 12px;
  margin-bottom: 14px;
  line-height: 1.5;
}
.grant-select-wrap {
  width: 100%;
  box-sizing: border-box;
  .grant-tag {
    margin-right: 8px;
    margin-bottom: 8px;
  }
  .grant-add-btn {
    text-align: center;
    color: var(--el-color-primary);
    cursor: pointer;
    font-size: 13px;
    padding: 4px 8px;
    border: 1px dashed var(--el-border-color);
    border-radius: 4px;
    &:hover {
      border-color: var(--el-color-primary);
      background: var(--el-color-primary-light-9);
    }
  }
  .grant-count {
    margin-top: 8px;
    font-size: 12px;
    color: var(--yq-font-color-desc, #909399);
  }
}
</style>
